var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: "VIEW_PORTFOLIO",
          expression: "'VIEW_PORTFOLIO'",
        },
      ],
      attrs: {
        id: `taggedProjectListModal-${_vm.index}`,
        size: "lg",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.projects_tagged_with", { tag: this.tag }),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.cancel")) + "\n    ")]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }